// extracted by mini-css-extract-plugin
export default {"btn":"Footer_btn__cGUcI"};